import { Link } from "react-router-dom";

const MODELS = [
  {
    tag: "Option 1",
    name: "Profit Sharing Model",
    icon: "ri-percent-line",
    accent: true,
    desc: "Your returns move with the resort's performance — perfect for investors who want to ride growth.",
    points: [
      "Higher earning potential",
      "Revenue linked to resort performance",
      "Participate in overall resort growth",
    ],
  },
  {
    tag: "Option 2",
    name: "Minimum Rental Model",
    icon: "ri-shield-check-line",
    accent: false,
    desc: "A guaranteed, fixed annual income — ideal for investors who prioritise stability and predictability.",
    points: [
      "Fixed annual income",
      "Lower-risk investment",
      "Predictable cash flow",
    ],
  },
];

export default function RevenueModels() {
  return (
    <section id="models" className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
            <i className="ri-equalizer-line"></i> Flexible Revenue Models
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-4 leading-tight">
            Choose How You <span className="italic text-primary-700">Earn</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
            Pick the model that best matches your financial goals — both are professionally
            structured for hassle-free ownership.
          </p>
          <Link
            to="/models"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-5 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
          >
            Compare Revenue Models
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mt-12">
          {MODELS.map((model) => (
            <article
              key={model.name}
              className={`relative rounded-2xl p-6 md:p-8 border ${
                model.accent
                  ? "bg-primary-700 border-primary-700 text-background-50"
                  : "bg-background-50 border-background-200"
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`text-xs font-semibold tracking-wide rounded-full px-3 py-1 ${
                    model.accent ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                  }`}
                >
                  {model.tag}
                </span>
                <span
                  className={`flex items-center justify-center w-11 h-11 rounded-full ${
                    model.accent ? "bg-background-50/15 text-accent-300" : "bg-primary-100 text-primary-700"
                  }`}
                >
                  <i className={`${model.icon} text-xl`}></i>
                </span>
              </div>

              <h3
                className={`font-heading text-2xl md:text-3xl mt-5 ${
                  model.accent ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {model.name}
              </h3>
              <p
                className={`text-sm mt-3 leading-relaxed ${
                  model.accent ? "text-background-100/85" : "text-foreground-600"
                }`}
              >
                {model.desc}
              </p>

              <ul className="mt-6 space-y-3">
                {model.points.map((point) => (
                  <li
                    key={point}
                    className={`flex items-start gap-2.5 text-sm font-medium ${
                      model.accent ? "text-background-50" : "text-foreground-800"
                    }`}
                  >
                    <i
                      className={`ri-check-line mt-0.5 ${
                        model.accent ? "text-accent-400" : "text-primary-600"
                      }`}
                    ></i>
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}